import { Injectable } from '@angular/core';
import { BehaviorSubject, Subject } from 'rxjs';
import { Employee } from 'src/app/Models/employee.model';

@Injectable({
  providedIn: 'root'
})
export class SharedSkillService {
  public searchedEmpId = new Subject<number>();
  selectedBox: any;
  CheckedEmployeeIds: any = [];
  unCheckedEmployeeIds: any[];
  unSelected: boolean;
  checkAll: any;
  employeesChecked: any[];
  submittedEmployeeIds: any;
  allApprove: boolean;
  constructor() { }
  private searchText = "";
  private availability = "";
  public empId = "";
  private compId = "";
  private subCompId = "";
  private subComp = "";
  private isViewMode: boolean;
  private selectedValueSource = new BehaviorSubject<string>('');
  private SelectedAll = new BehaviorSubject<boolean>(false);
  private profileStatus = new BehaviorSubject<string>('');
  private unCheckedsubject = new Subject<boolean>();
  private CheckedEmployeeStatus = new Subject<boolean>()
  profileStatus$ = this.profileStatus.asObservable();
  selectedValue$ = this.selectedValueSource.asObservable();
  selectedAllCheckBoxes$ = this.SelectedAll.asObservable();
  private isEditable: boolean;
  private pagenavigationId = new BehaviorSubject<any>(0);
  pagenavigationId$ = this.pagenavigationId.asObservable();
  private resumestatusId = new BehaviorSubject<any>(0);
  Resumestatusid$ = this.resumestatusId.asObservable();

  setresumestate(value: number) {
    this.resumestatusId.next(value);
  }

  setIsEditable(value) {
    this.isEditable = value;
  }
  public comptencyid = 0;
  public comptency = ""
  setSearchText(value) {
    this.searchText = value;
  }
  setAvailability(value) {
    this.availability = value;
    this.selectedValueSource.next(this.availability);
  }
  setEmployeeId(value) {
    this.empId = value;
    this.searchedEmpId.next(value);
  }
  setCompId(value) {
    this.compId = value;
  }
  setMode(value) {
    this.isViewMode = value;
  }
  setSubCompId(value) {

    this.subCompId = value;
  }
  setSubComp(value) {
    this.subComp = value;
  }
  setSelected(employeeIds: any, value) {
    if (!value) {
      this.unCheckedEmployeeIds = [];
      this.CheckedEmployeeIds = [];
    }
    else {
      this.CheckedEmployeeIds = employeeIds;
    }
    if (this.CheckedEmployeeIds.length == 0) {
      this.CheckedEmployeeStatus.next(false);
    }
    this.SelectedAll.next(value);
    this.allApprove = value;
  }
  setProfileStatus(value) {
    this.profileStatus.next(value);
  }
  getCheckedEmployeeIds() {
    return this.CheckedEmployeeIds;
  }
  updateCheckedEmployeeId(employeeId, checked) {
    if (checked) {
      if (!this.CheckedEmployeeIds.includes(employeeId)) {
        this.CheckedEmployeeIds.push(employeeId);
      }
      if (this.CheckedEmployeeIds.length > 0) {
        this.CheckedEmployeeStatus.next(true);
      }
      this.checkAll = this.submittedEmployeeIds.every(employee => this.CheckedEmployeeIds.includes(employee))
      if (this.checkAll) {
        this.unCheckedsubject.next(this.checkAll);
      }
    }
    else {
      if (!this.unCheckedEmployeeIds.includes(employeeId)) {
        this.unCheckedEmployeeIds.push(employeeId);
      }
      this.CheckedEmployeeIds = this.CheckedEmployeeIds.filter(id => id !== employeeId);
      this.checkAll = this.submittedEmployeeIds.every(employee => this.CheckedEmployeeIds.includes(employee));
      this.unCheckedsubject.next(this.checkAll);
      if (this.CheckedEmployeeIds.length == 0) {
        this.CheckedEmployeeStatus.next(false);
      }
      else {
        this.CheckedEmployeeStatus.next(true);
      }
    }
  }
  getUnselected() {
    return this.unCheckedsubject;
  }
  getSelected() {
    return this.selectedBox;
  }
  getCheckedEmployeeStatus() {
    return this.CheckedEmployeeStatus;
  }
  getAllApprove() {
    return this.allApprove;
  }
  getIsEditable() {
    return this.isEditable;
  }
  getUnCheckedEmployeeIds() {
    return this.unCheckedEmployeeIds;
  }
  getAllSubmittedEmployeeIds(value) {
    this.submittedEmployeeIds = value;
  }
  getMode() {
    return this.isViewMode;
  }
  getSearchText() {
    return this.searchText;
  }
  getAvailability() {
    return this.availability;
  }
  getEmployeeId() {
    return this.empId;
  }
  getCompId() {
    return this.compId;
  }
  getsubCompId() {
    return this.subCompId;
  }
  getsubComp() {
    return this.subComp;
  }

  setpagenavigationId(value: any) {
    this.pagenavigationId.next(value);
  }
}
